import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import CircularProgress from '@mui/material/CircularProgress';
import useHook from './useHook';
import styles from './styles.module.scss';

type LoaderProps = {
    width: number
    height: number
    spinner?: boolean
    skeleton?: boolean
    variant?: 'text' | 'rectangular' | 'circular' | 'rounded'
    color?: any
    opacity?: number | string
}

const Loader = ({ width, height, spinner, skeleton, variant, color, opacity }: LoaderProps) => {

  const { contenedorRef, widthC, heightC } = useHook({ width, height });

  return (
    <div
      className={styles.contenedor}
      ref={contenedorRef}
      style={{ maxWidth: width, maxHeight: height, height: `${heightC}px` }}
    >
      {spinner &&
                <CircularProgress
                  color={color}
                  style={{ opacity }}
                />
      }
      {skeleton &&
                <Skeleton
                  variant={variant}
                  width={widthC}
                  height={heightC}
                  style={{ margin: 'auto', borderRadius: '3px', position: 'absolute', left: 0, top: 0, right: 0 }}
                />
      }
    </div>
  );
};

export default Loader;
